import React, {Component} from 'react';
import StackTeamsExposure from './stack-teams-exposure';
import StackTeams from './stack-teams';
import StackTeamsChecking from './stack-teams-checking';
import TotalMinExposure from './total-min-exposure';
import LineGroupsChecking from './line-groups-checking';
import PPLinesChecking from './pp-lines-checking';
import MirrorStack from './mirror-stack';

class StackOptions extends Component {
    render() {
        const {stackNumber} = this.props;
        const maxStackNumber = 3;
        const getPrevStackNumber = (number) => (number === 1 ? maxStackNumber : number - 1);
        const getNextStackNumber = (number) => (number >= maxStackNumber ? 1 : number + 1);

        return (
            <div key={stackNumber} className="team-stack nhl-stack">
                <h3>STACK {stackNumber}</h3>
                <div className="form-row-new">
                    <div className="form-inline">
                        <strong className="form-text">
                            Team <br className="hide-desktop" /> exposures:
                        </strong>
                        <StackTeamsExposure stackNumber={stackNumber} />
                    </div>
                    <TotalMinExposure stackNumber={stackNumber} />
                </div>
                <div className="chk-all-stack">
                    <MirrorStack
                        sourceStackNumber={getPrevStackNumber(stackNumber)}
                        destinationStackNumber={stackNumber}
                    />
                    <div className="checkbox">
                        <StackTeamsChecking stackNumber={stackNumber} />
                    </div>
                    <MirrorStack
                        sourceStackNumber={getNextStackNumber(stackNumber)}
                        destinationStackNumber={stackNumber}
                    />
                </div>
                <div className="stack-container">
                    <StackTeams stackNumber={stackNumber} />
                </div>
                <div className="chk-group-row">
                    <LineGroupsChecking stackNumber={stackNumber} />
                    <PPLinesChecking stackNumber={stackNumber} />
                </div>
            </div>
        );
    }
}

export default StackOptions;
